import { render, staticRenderFns } from "./UpLoadPic.vue?vue&type=template&id=3a852406&"
import script from "./UpLoadPic.vue?vue&type=script&lang=js&"
export * from "./UpLoadPic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports